import '.g9{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ga{padding-left:1.5rem;}.ssr-plugin'
import '.gb{margin:1rem 0;}.ssr-plugin'
import '.gc{color:var(--gray-700);}.ssr-plugin'
import '.gd{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g9 ga gb gc gd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
